<template>
    <div class="page">
        <div class="workspace">
            <div class="ws-unit">
                <div class="ws-unit-header ">
                    <div>
                        <el-button
                            type="primary"
                            size="small"
                            round
                            icon="el-icon-plus"
                            @click="create"
                        >添加</el-button>
                    </div>
                    <div class="ws-unit-toolbar">
                        <el-form inline>
                            <el-form-item>
                            <el-input placeholder="请输入关键词" v-model="filter.keyword" clearable @clear="onSearch" class="input-with-select" size="mini">
                              <el-select v-model="filter.column" slot="prepend" placeholder="请选择" size="mini" style="width: 100px">
                                <el-option label="公司名" value="name"></el-option>
                                <el-option label="联系人" value="contact"></el-option>
                                <el-option label="联系电话" value="phone"></el-option>
                                <el-option label="联系邮箱" value="email"></el-option>
                              </el-select>
                              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                            </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ws-unit-body">
                    <company-table ref="table" />
                </div>
            </div>
        </div>
        <company-form
            @success="onSaveSuccess"
            ref="dialog"
        />
    </div>
</template>

<script>
import CompanyTable from "./Table";
import CompanyForm from "./Form";

export default {
    name: "News",
    components: {
        CompanyTable,
        CompanyForm
    },
    data: function() {
        return {
            filter: {
                column: "公司名",
                keyword: null
            }
        };
    },
    methods: {
        create() {
            this.$refs.dialog.show();
        },
        onSearch() {
            this.$refs.table.loadData(1);
        },
        onSaveSuccess() {
            this.$refs.table.loadData();
        }
    }
};
</script>

<style scoped>
</style>